"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CaptionSt = require("./Caption.st.css");

var _Ellipsis = _interopRequireWildcard(require("../common/Ellipsis"));

var _EllipsisCommon = require("../common/PropTypes/EllipsisCommon");

var _excluded = ["dataHook", "className", "tagName", "caption", "light", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CaptionWithEllipsis = function CaptionWithEllipsis(_ref) {
  var dataHook = _ref.dataHook,
      className = _ref.className,
      tagName = _ref.tagName,
      caption = _ref.caption,
      light = _ref.light,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _extractEllipsisProps = (0, _Ellipsis.extractEllipsisProps)(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  return /*#__PURE__*/_react["default"].createElement(_Ellipsis["default"], (0, _extends2["default"])({}, ellipsisProps, {
    wrapperClassName: _CaptionSt.classes[caption],
    render: function render(_ref2) {
      var ref = _ref2.ref,
          ellipsisClasses = _ref2.ellipsisClasses;
      return /*#__PURE__*/_react["default"].createElement(tagName, _objectSpread({
        ref: ref,
        className: (0, _CaptionSt.st)(_CaptionSt.classes.root, {
          caption: caption
        }, ellipsisClasses(className)),
        'data-hook': dataHook,
        'data-light': light
      }, componentProps), children);
    }
  }));
};

CaptionWithEllipsis.displayName = 'Caption';
CaptionWithEllipsis.propTypes = _objectSpread({
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes["default"].string,

  /** class to be applied to the root element */
  className: _propTypes["default"].string,

  /** tag name that will be rendered */
  tagName: _propTypes["default"].string,
  caption: _propTypes["default"].oneOf(['c1', 'c2']),

  /** make the text color lighter */
  light: _propTypes["default"].bool
}, _EllipsisCommon.EllipsisCommonProps);
CaptionWithEllipsis.defaultProps = _objectSpread({
  caption: 'c1',
  tagName: 'span'
}, _Ellipsis["default"].defaultProps);
var _default = CaptionWithEllipsis;
exports["default"] = _default;